module.exports = __webpack_public_path__ + "img/product-default.a10ab93c.png";